import { getEmbedVideoUrl, getEmbedCodeUrl } from '@/services/Utils'
import { HIT_TYPES } from '@/config/constants'

import PlayerModel from './PlayerModel'
import CommentModel from './CommentModel'

export default (hit) => {
  if (!hit) return

  if (hit.player) {
    hit.player = PlayerModel(hit.player)
  }

  if (hit.type === HIT_TYPES.CODE) {
    hit.code_embed = getEmbedCodeUrl(hit.path)
  } else if (hit.type === HIT_TYPES.VIDEO) {
    hit.video_embed = getEmbedVideoUrl(hit.path)
  }

  hit.comments = hit.comments || []
  hit.comments = hit.comments.map(CommentModel)
  hit.comments_count = hit.comments_count || 0
  hit.likes_count = hit.likes_count || 0
  hit.user_liked = hit.user_liked || false

  return Object.defineProperties(hit, {})
}



// WEBPACK FOOTER //
// ./src/services/Models/HitModel.js